<template>
  <router-link class="thumb_wrap horsey-gridey" :to="{ path }">
    <div class="image">
      <img
        :src="$imgUrl(`horse_thumbnails/${horse.thumb}`)"
        :alt="horse.thumb"
      />
    </div>
    <div class="name">
      <div>
        <p>{{ horse.name }}</p>
        <p class="horse-caption" v-if="$te(`texts.horses.${horse.name}.caption`)">
          <i>{{ $t(`texts.horses.${horse.name}.caption`) }}</i>
        </p>
      </div>
      <img :src="$imgUrl('misc/arrow_right.svg')" alt="arrow" />
    </div>
  </router-link>
</template>

<script>
import { trim } from "lodash";

export default {
  props: {
    horse: {
      type: Object,
      defaulf: () => {},
    },
  },
  data() {
    return {
      path: `/${trim(this.$t("menu.url.horses"))}/${this.horse.slug}`,
    };
  },
};
</script>
